import { createFileRoute } from "@tanstack/react-router";
import type { ReactNode } from "react";
import {
  AffiliatesPage,
  parseAffiliatesSearch,
} from "@/affiliates/AffiliatesPage";

export const Route = createFileRoute(
  "/_authenticated/platform-management_/affiliates",
)({
  validateSearch: parseAffiliatesSearch,
  component: AffiliatesRoute,
});

function AffiliatesRoute(): ReactNode {
  const { q } = Route.useSearch();
  const navigate = Route.useNavigate();

  return (
    <AffiliatesPage
      query={q ?? ""}
      onQueryChange={(query) => {
        // `replace`, so typing a query does not fill the history stack.
        void navigate({
          replace: true,
          search: { q: query === "" ? undefined : query },
        });
      }}
    />
  );
}
